import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';

const Sidebar = () => {
  const location = useLocation();
  const { isAdmin, isLimitedAdmin } = useAuth();

  const links = (() => {
    if (isAdmin) {
      return [
        { path: '/admin/dashboard', label: 'Dashboard' },
        { path: '/admin/main-page', label: 'Main Page' },
        { path: '/admin/products', label: 'Products' },
        { path: '/admin/carousels', label: 'Carousels' },
        { path: '/admin/users', label: 'Users' },
        { path: '/admin/orders', label: 'Orders' },
        { path: '/admin/settings', label: 'Site Settings' },
      ];
    }

    if (isLimitedAdmin) {
      return [
        { path: '/admin/products', label: 'Products' },
        { path: '/admin/orders', label: 'Orders' },
      ];
    }

    return [
      { path: '/admin/orders', label: 'Orders' },
    ];
  })();

  return (
    <aside style={{
      width: '250px',
      backgroundColor: 'var(--color-surface)',
      padding: '20px',
      borderRight: '1px solid var(--color-border)'
    }}>
      <nav>
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {links.map((link) => (
            <li key={link.path} style={{ marginBottom: '10px' }}>
              <Link
                to={link.path}
                style={{
                  display: 'block',
                  padding: '10px 15px',
                  textDecoration: 'none',
                  color: location.pathname === link.path ? 'var(--color-text)' : 'var(--color-muted)',
                  backgroundColor: location.pathname === link.path ? 'rgba(236, 204, 15, 0.22)' : 'transparent',
                  borderRadius: '4px',
                  fontWeight: location.pathname === link.path ? 'bold' : 'normal'
                }}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
